var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLineAnalysisRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 3C1.875 2.37868 2.37868 1.875 3 1.875H17C17.6213 1.875 18.125 2.37868 18.125 3V17C18.125 17.6213 17.6213 18.125 17 18.125H3C2.37868 18.125 1.875 17.6213 1.875 17V3ZM3.125 3.125V5.625H16.875V3.125H3.125ZM16.875 6.875H3.125V9.375H16.875V6.875ZM16.875 10.625H3.125V13.125H16.875V10.625ZM16.875 14.375H3.125V16.875H16.875V14.375Z",
    fill: "#EA011D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLineAnalysisRed);
export default __webpack_public_path__ + "static/media/iconLineAnalysisRed.f246a7f0edff39d8eea0df1406c6cc90.svg";
export { ForwardRef as ReactComponent };